import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsThemightyComponent } from './simple-icons-themighty.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsThemightyComponent ],
    exports:      [ SimpleIconsThemightyComponent ],
    bootstrap:    []
})
export class SimpleIconsThemightyModule {}
